/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import {
	get,
	post
} from '@/utils/ajax'
import wx from 'weixin-js-sdk'

import tabbar from './views/components/tabbar.vue'
Vue.component("tabbar", tabbar)

import navTitle from './views/components/navTitle.vue'
Vue.component("navTitle", navTitle)

import moment from 'moment'

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$wx = wx
Vue.prototype.moment = moment

Vue.config.productionTip = false

import {
	Picker,
	Popup,
	Toast,
	DatetimePicker,
	Area,
	Popover,
	Icon,
	Uploader,
	Overlay,
	Badge,
	Dialog,
	IndexBar,
	IndexAnchor,
	DropdownMenu,
	DropdownItem,
	List,
	Cell,
	Tab, 
	Tabs,
	ImagePreview,
	Loading
} from 'vant';

Vue.use(Picker)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(DatetimePicker)
Vue.use(Area)
Vue.use(Popover)
Vue.use(Icon)
Vue.use(Uploader)
Vue.use(Badge)
Vue.use(Overlay)
Vue.use(Dialog)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(List)
Vue.use(Cell)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(ImagePreview)
Vue.use(Loading)

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)


function addZero(v, size) {
	for (var i = 0, len = size - (v + "").length; i < len; i++) {
		v = "0" + v;
	};
	return v + "";
}

function formatDate(date, formatStr) {
	var arrWeek = ['日', '一', '二', '三', '四', '五', '六'],
		str = formatStr.replace(/yyyy|YYYY/, date.getFullYear()).replace(/yy|YY/, addZero(date.getFullYear() % 100, 2)).replace(
			/mm|MM/, addZero(date.getMonth() + 1, 2)).replace(/m|M/g, date.getMonth() + 1).replace(/dd|DD/, addZero(date.getDate(),
			2)).replace(/d|D/g, date.getDate()).replace(/hh|HH/, addZero(date.getHours(), 2)).replace(/h|H/g, date.getHours()).replace(
			/ii|II/, addZero(date.getMinutes(), 2)).replace(/i|I/g, date.getMinutes()).replace(/ss|SS/, addZero(date.getSeconds(),
			2)).replace(/s|S/g, date.getSeconds()).replace(/w/g, date.getDay()).replace(/W/g, arrWeek[date.getDay()]);
	return str;
}

Vue.filter("formatDate_noS", (data) => {
	return formatDate(new Date(data * 1000), "YYYY-MM-DD")
})
Vue.filter("formatDate", (data) => {
	return formatDate(new Date(data * 1000), "YYYY-MM-DD HH:ii:ss")
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
